import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { settingGet } from '../actions/triggerAction';
import { Box, Typography } from '@material-ui/core';
import Utils from '../../../helpers/Utils';
import { AddorEditGlobalTriggerStyles } from '../TriggerStyle';
import TriggerSettingSkeleton from './TriggerSettingSkeleton';
import TriggerItem from './TriggerItem/TriggerItem';
import ActionItem from './ActionItem/ActionItem';
import TriggerSettingsHeader from './TriggerSettingsHeader';
import "./trigger-settings.css";

const TriggerSettings = ({ modalData, triggerId, handleClose }) => {
    const dispatch = useDispatch();
    const { loading, data, response } = useSelector(state => state.triggerSettingReducer);

    useEffect(() => {
        dispatch(settingGet({
            triggerRuleId : triggerId
        }));
    },[])

    const { root, contentWrapper } = AddorEditGlobalTriggerStyles();

    return (
        <Box minWidth={1000} minHeight={850} className={`trigger__settings ${root}`} sx={{marginTop: "0 !important"}}>

            {
                response && 
                <div className="row">
                    <div className="col">
                        { response.status === 'error' ?
                            <div className="alert alert-danger" role="alert">
                                <div className="alert-text">
                                    {response.message}
                                </div>
                            </div> :
                            <div className="alert alert-success" role="alert">
                                <div className="alert-text">
                                    {response.message}
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }

            {
                loading ? 
                <TriggerSettingSkeleton /> : 
                <>
                    {/* <div className={triggerSettingsHeader}
                    >
                        <Typography className={titleHeader}>
                            Trigger and Actions
                        </Typography>
                    </div> */}
                    <TriggerSettingsHeader handleClose={handleClose} />



                    <div className={`trigger__custom_row ${contentWrapper}`}>
                        {data && <TriggerItem modalData={modalData} />}
                        {data && <ActionItem />}
                    </div>
                </>
            }

        </Box>
    );
};

export default TriggerSettings;